import { cleanOrigin, cleanArguments } from '../functions/utils.js';

// Auto-découverte : tout fichier dans ../functions/ (sauf utils.js) est une fonction
const context = require.context('../functions', false, /\.js$/);

const blockToFunctionDict = {};
const templates = [];

context.keys().forEach(key => {
  if (key === './utils.js') return;
  const mod = context(key).default;
  if (!mod) return;
  templates.push(mod);
  if (mod.generate) {
    blockToFunctionDict[mod.functionKey] = mod.generate;
  }
});

const FunctionBlockToJS = {
  // Liste des templates UI pour le dropdown (remplace template_fonctions_excel.json)
  templates,

  convertFunctionBlockToJS(functionBlock, toHtml = true) {
    let displayCode = "";
    let safeCode = "";

    let cleanArgs = [];
    let isArgumentCol = [];
    if (functionBlock.arguments) {
      const result = cleanArguments(functionBlock.arguments);
      cleanArgs = result.cleanArgs;
      isArgumentCol = result.isArgumentCol;
    }

    const functionKey = functionBlock.functionKey;

    // fonctions spéciales sans génération de code (ex: DEUX POINTS)
    if (functionBlock.target === undefined || blockToFunctionDict[functionKey] === undefined) {
      return { displayCode, safeCode };
    }

    let targetArray = [...functionBlock.target];

    // si pas de destination, on utilise l'origine comme destination
    if ((!targetArray || targetArray.length === 0) && functionBlock.origin) {
      targetArray = [...functionBlock.origin];
    }

    const allOrigins = functionBlock.origin ? functionBlock.origin.map(o => cleanOrigin(o)) : [];
    const templateDef = templates.find(t => t.functionKey === functionKey);
    const isMultiOrigin = templateDef && templateDef.multiOrigin;

    for (let i = 0; i < targetArray.length; i++) {
      if (isMultiOrigin && i > 0) break; // une seule destination pour les fonctions multi-origines
      const destination = `data['${targetArray[i].value}']`;
      let origin = "";
      if (functionBlock.origin && i < functionBlock.origin.length) {
        origin = cleanOrigin(functionBlock.origin[i]);
      }
      const functionJS = blockToFunctionDict[functionKey](destination, origin, cleanArgs, isArgumentCol, allOrigins);
      displayCode += functionJS.displayCode;
      if (toHtml) displayCode += "<br/>";
      safeCode += functionJS.safeCode;
    }

    return { displayCode, safeCode };
  }
};

export default FunctionBlockToJS;